module.exports = __webpack_public_path__ + "static/media/aeronave.2011629b.glb";